import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

/** Public help / support route. Contact details come from Admin → Communications branding; nothing here is hard-coded. */
export default function HelpPage() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/brand-assets/support-info`).then((r) => setD(r.data)).catch(() => setErr(true)); }, []);
  return (
    <main className="min-h-screen bg-slate-50 px-6 py-16" data-testid="help-page">
      <div className="mx-auto max-w-xl rounded-2xl border border-slate-200 bg-white p-8">
        <h1 className="text-2xl font-bold text-slate-900">Support</h1>
        <p className="mt-2 text-sm text-slate-600">For sign-in or account help, contact {d?.company || "us"} using the details below.</p>
        {err && <p className="mt-4 text-sm text-rose-700" data-testid="help-error">Support details are unavailable right now — please try again shortly.</p>}
        {d && (
          <dl className="mt-6 space-y-3 text-sm" data-testid="help-contacts">
            {d.email && <div><dt className="text-slate-500">Email</dt><dd><a className="font-medium text-sky-700 underline" href={`mailto:${d.email}`} data-testid="help-email">{d.email}</a></dd></div>}
            {d.phone && <div><dt className="text-slate-500">Phone</dt><dd><a className="font-medium text-sky-700 underline" href={`tel:${d.phone.replace(/\s/g, "")}`} data-testid="help-phone">{d.phone}</a></dd></div>}
            {d.support_url && <div><dt className="text-slate-500">Support portal</dt><dd><a className="font-medium text-sky-700 underline" href={d.support_url} target="_blank" rel="noreferrer" data-testid="help-portal">{d.support_url}</a></dd></div>}
            {!d.email && !d.phone && !d.support_url && <div className="text-slate-600" data-testid="help-unconfigured">Support contact has not been configured yet. Please contact your account administrator.</div>}
          </dl>
        )}
        <Link to="/login" className="mt-8 inline-block text-sm font-semibold text-slate-900 underline" data-testid="help-back-login">Back to sign in</Link>
      </div>
    </main>
  );
}
